import React, { useState } from 'react';
import { VscFeedback, VscFiles, VscCommentDiscussion } from 'react-icons/vsc';
import useDashboard from '../../../hooks/dashboard/useDashboard';
import { CustomLineChart } from './CustomLineChart';
import { MdArrowOutward } from 'react-icons/md';
import { CustomBarChart } from './CustomBarChart';
import { useAppContext } from '../../../context/Context';
import TimeRangeSelector from './TimeStamp';
import ScalewayRatelimitsCard from "./ScalewayRatelimitsCard";


export default function Dashboard() {
    const [{ user, isAwaitingCookieAuth, isAdminVirteem }] = useAppContext();

    // Vérification des données utilisateur
    console.log("User data:", user);

    // Initialisation des dates par défaut
    const today = new Date();
    const defaultStartDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];

    // Ths Date object automatically converts invalid dates by adding or subtracting years or months as needed.
    // Day 0 is converted to the last day if the previous month
    const defaultEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];

    const [startDate, setStartDate] = useState(defaultStartDate); // Initialisation avec des dates par défaut
    const [endDate, setEndDate] = useState(defaultEndDate); // Initialisation avec des dates par défaut

    console.log("Initial start date:", startDate);
    console.log("Initial end date:", endDate);

    // États pour la gestion des données du dashboard
    const [{ dataPoints, company_uuid, feedbackStats, planUsage }] = useDashboard(startDate, endDate);


    console.log("Data points:", dataPoints);
    console.log("Company UUID:", company_uuid);
    console.log("Feedback stats:", feedbackStats);
    console.log("Plan usage:", planUsage);

    const handleDateChange = (start, end) => {
        setStartDate(start);
        setEndDate(end);
        console.log("Selected start date:", start);
        console.log("Selected end date:", end);
    };

    if (!user) {
        console.log("User data not loaded, displaying loading state...");
        return <div>Chargement des informations utilisateur...</div>;
    }

    if (!dataPoints || !company_uuid) {
        console.log("Data not ready, displaying loading state...");
        return <div>Chargement des données du tableau de bord...</div>;
    }
    if (isAwaitingCookieAuth) {
        console.log("Data for auth not ready, displaying loading state...");
        return <div>Chargement...</div>;
    }
    return (
        <div className='px-12'>
            <div className='pb-6 text-black space-y-1'>
                <div className='text-3xl font-semibold'>Bonjour {user.first_name}</div>
                <div className='text-xs font-bold'>Content de vous revoir !</div>
                <TimeRangeSelector onDateChange={handleDateChange} />
            </div>

            {/* Affichage des variables calculées 
            <div className='pb-6'>
                <h2 className='text-2xl font-bold'>Variables calculées concernant les feedbacks</h2>
                <ul className='list-disc pl-5 space-y-2'>
                    <li>Total des feedbacks: {feedbackStats?.totalCountFeedbacks ?? 0}</li>
                    <li>Feedbacks sans note: {feedbackStats?.noGrade ?? 0}</li>
                    <li>Feedbacks positifs: {feedbackStats?.goodGrade ?? 0}</li>
                    <li>Feedbacks moyens: {feedbackStats?.mediumGrade ?? 0}</li>
                    <li>Feedbacks négatifs: {feedbackStats?.badGrade ?? 0}</li>
                    <li>Total des feedbacks traités: {feedbackStats?.totalHandledFeedbacks ?? 0}</li>
                    <li>Pourcentage d'augmentation des feedbacks traités ce mois-ci: {feedbackStats?.percentageIncreaseFeedbacksHandled?.toFixed(2) ?? 0}%</li>
                    <li>Nouveaux feedbacks ce mois-ci: {feedbackStats?.totalNewFeedbacksThisMonth ?? 0}</li>
                </ul>
            </div>*/}

            <div className='pb-6 flex gap-8 flex-wrap'>
                <div className='w-5/12 pb-4 bg-white p-8 rounded-xl shadow flex flex-col justify-between text-black text-base flex-grow'>
                    <div className='pb-6'>
                        <div className='font-bold'>Total des retours</div>
                        <div className='opacity-25 font-bold text-sm'>Sur la période</div>
                    </div>
                    <div className='flex gap-6 text-black flex-wrap justify-center'>
                        <div className='w-2/3 pt-8 grow'>
                            {feedbackStats && (
                                <CustomBarChart
                                    data={{
                                        noGrade: feedbackStats.noGrade,
                                        badGrade: feedbackStats.badGrade,
                                        mediumGrade: feedbackStats.mediumGrade,
                                        goodGrade: feedbackStats.goodGrade
                                    }}
                                />
                            )}
                        </div>
                        <div className='space-y-5 flex flex-col justify-center'>
                            <div className='flex gap-1 items-center'>
                                <div className='rounded-full h-2 w-2 bg-perso-chartGreen' />
                                <div className='text-xs'>Positifs</div>
                            </div>
                            <div className='flex gap-1 items-center'>
                                <div className='rounded-full h-2 w-2 bg-perso-chartOrange' />
                                <div className='text-xs'>Moyens</div>
                            </div>
                            <div className='flex gap-1 items-center'>
                                <div className='rounded-full h-2 w-2 bg-perso-chartRed' />
                                <div className='text-xs'>Négatifs</div>
                            </div>
                            <div className='flex gap-1 items-center'>
                                <div className='rounded-full h-2 w-2 bg-perso-chartGray' />
                                <div className='text-xs'>Sans avis</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='rounded-xl w-auto border p-8 shadow bg-white text-black text-base flex flex-col justify-between min-h-64 flex-grow'>
                    <div className="pb-6">
                        <div className='font-bold'>Total des retours</div>
                        <div className='opacity-25 font-bold text-sm'>Sur la période</div>
                    </div>
                    <div className='space-y-4 grow flex flex-col justify-center'>
                        <div className='flex gap-2 w-full justify-center'>
                            <VscFeedback className='w-12 h-12 text-black' />
                            <div className='text-4xl font-extrabold text-perso-lightBlue'>
                                {feedbackStats?.totalCountFeedbacks ?? 0}
                            </div>
                        </div>
                        <div className='flex flex-col gap-2'>
                            <div className='opacity-25 font-bold text-sm'>Par rapport à la période précédente</div>
                            <div className='text-lg font-bold w-full justify-center flex gap-1 items-center'>
                                <MdArrowOutward
                                    className={`${feedbackStats?.percentageIncreaseCountThisMonth < 0 && 'rotate-180'} w-5 h-5 text-virteem-darkBlueLight`} />
                                <div className="text-perso-blue">
                                    {feedbackStats?.percentageIncreaseCountThisMonth
                                        ? `${parseInt(feedbackStats.percentageIncreaseCountThisMonth).toFixed(0)}%`
                                        : "0%"}
                                </div>
                            </div>
                        </div>
                        <div className='text-base font-bold w-full text-center'>
                            +{feedbackStats?.totalNewFeedbacksThisMonth ?? 0} feedbacks
                        </div>
                    </div>
                </div>
                <div className='rounded-xl w-auto border p-8 shadow bg-white text-black text-base flex flex-col justify-between min-h-64 flex-grow'>
                    <div className="pb-6">
                        <div className='font-bold'>Retours traités</div>
                        <div className='opacity-25 font-bold text-sm'>Sur la période</div>
                    </div>
                    <div className='space-y-4 grow flex flex-col justify-center'>
                        <div className='flex gap-2 w-full justify-center'>
                            <VscFeedback className='w-12 h-12 text-black' />
                            <div className='text-4xl font-extrabold text-perso-lightBlue'>
                                {isNaN(feedbackStats?.totalHandledFeedbacks) || isNaN(feedbackStats?.totalCountFeedbacks) || feedbackStats?.totalCountFeedbacks === 0
                                    ? "0%"
                                    : `${(feedbackStats.totalHandledFeedbacks / feedbackStats.totalCountFeedbacks * 100).toFixed(0)}%`}
                            </div>
                        </div>
                        <div className='flex flex-col gap-2'>
                            <div className='opacity-25 font-bold text-sm'>Par rapport à la période précédente</div>
                            <div className='text-lg font-bold w-full justify-center flex gap-1 items-center'>
                                <MdArrowOutward
                                    className={`${feedbackStats?.percentageIncreaseFeedbacksHandled < 0 && 'rotate-180'} w-5 h-5 text-virteem-darkBlueLight`} />
                                <div className="text-perso-blue">
                                    {feedbackStats?.percentageIncreaseFeedbacksHandled
                                        ? `${parseInt(feedbackStats.percentageIncreaseFeedbacksHandled).toFixed(0)}%`
                                        : "0%"}
                                </div>
                            </div>
                        </div>
                        <div className='text-base font-bold w-full text-center'>
                            +{feedbackStats?.totalFeedbacksHandledThisMonth ?? 0} feedbacks traités
                        </div>
                    </div>
                </div>
                <div className='h-80 pb-16 bg-white w-2/5 p-8 rounded-xl shadow flex-col text-base flex-grow'>
                    <div className="pb-6">
                        <div className='font-bold text-black'>Total des questions</div>
                        <div className='opacity-25 font-bold text-black text-sm'>Sur la période</div>
                    </div>
                    <div className="p-2 flex justify-center">
                        <CustomLineChart dataPoints={dataPoints} />
                    </div>
                </div>
                <div
                    className='rounded-xl w-auto border p-8 shadow bg-white text-black text-base flex flex-col justify-between min-h-64 flex-grow'>
                    <div className="pb-6">
                        <div className='font-bold'>Total des quotas</div>
                    </div>
                    <div className='space-y-4 grow flex flex-col justify-center gap-2'>
                        <div className='flex flex-col gap-2 w-full justify-center items-center'>
                            <div className='flex w-full justify-center gap-2'>
                                <VscCommentDiscussion className='w-12 h-12 text-black' />
                                <div className='text-4xl font-extrabold text-perso-lightBlue'>
                                    {isNaN(planUsage?.request_count) || isNaN(planUsage?.plan_request_quota) ?
                                        "0%"
                                        : `${(planUsage.request_count / planUsage.plan_request_quota * 100).toFixed(0)}%`}
                                </div>
                            </div>
                            <div className='opacity-25 font-bold text-black text-sm'>Requêtes exécutées sur le mois</div>
                        </div>
                        <div className='flex flex-col gap-2 w-full justify-center items-center'>
                            <div className='flex w-full justify-center gap-2'>
                                <VscFiles className='w-12 h-12 text-black' />
                                <div className='text-4xl font-extrabold text-perso-lightBlue'>
                                    {isNaN(planUsage?.document_total) ?
                                        "0" : `${planUsage.document_total}`
                                    }/{isNaN(planUsage?.plan_document_quota) ? "0" : planUsage.plan_document_quota}
                                </div>
                            </div>
                            <div className='opacity-25 font-bold text-black text-sm'>Nombre de documents utilisés</div>
                        </div>
                    </div>
                </div>
                {isAdminVirteem && <ScalewayRatelimitsCard/>}
            </div>
        </div>
    );
}
